// Port of api/fuel/app/classes/filter/search/games/rules/query/designers.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'designers',
	isIndex: function() { return 'designer' }
})
